export default __webpack_public_path__ + "static/media/head.37a64eb1.png";